import React, { useState, useEffect } from 'react';
import {
  Container, Typography, TextField,
  Button, Paper, Alert, CircularProgress, Box 
} from '@mui/material';
import Editor from 'react-simple-wysiwyg';
import DashboardLayout from '../../Sidebar/DashboardLayout';
import axios from 'axios';
import './addEmailTemplate.css';
import { useNavigate } from 'react-router-dom'; 
import emailTemplateSkeleton from './emailTemplateSkeleton';





const AddEmailTemplate = () => {
  const navigate = useNavigate(); 
  const [form, setForm] = useState({
    nom: '', sujet: '', type: '', contenu: '',
  });

  const [status, setStatus] = useState({ type: '', text: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
  if (!form.contenu) {
    setForm(prev => ({ ...prev, contenu: emailTemplateSkeleton }));
  }
}, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ type: '', text: '' });

    if (!form.nom || !form.sujet || !form.type || !form.contenu) {
      return setStatus({ type: 'error', text: 'Tous les champs sont obligatoires.' });
    }

    try {
      setLoading(true);
      
      const { data: existingTemplates } = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates`);
       
      const alreadyExists = existingTemplates.some(t => t.type?.toLowerCase() === form.type.toLowerCase());
       
      if (alreadyExists) {
        setStatus({ type: 'error', text: 'Un modèle avec ce type existe déjà.' });
        setLoading(false);
        return;
      }
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates`, form);
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/admin/email-templates/save-json`);
      setStatus({ type: 'success', text: 'Modèle ajouté avec succès.' });
      setTimeout(() => {
      navigate('/admin/email-templates');
      }, 500);
    } catch (err) {
      setStatus({ type: 'error', text: err.response?.data?.message || 'Erreur lors de l’ajout.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Container maxWidth="md">
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography variant="h5">
            Ajouter un modèle d'e-mail
          </Typography>
          <Button variant="outlined" onClick={() => navigate('/admin/email-templates')}>
            Voir les modèles
          </Button>
        </Box>

        <Paper elevation={3} className="add-email-template">

          <form onSubmit={handleSubmit}>
            <TextField
              label="Nom du modèle"
              name="nom"
              value={form.nom}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Sujet"
              name="sujet"
              value={form.sujet}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <TextField
              label="Type"
              name="type"
              value={form.type}
              onChange={handleChange}
              fullWidth
              margin="normal"
              required
            />
            <Typography variant="caption" color="textSecondary" style={{ marginLeft: 4 }}>
              ⚠️ Ce champ doit être conforme (ex : "inscription_utilisateur", "confirmation_mot_de_passe") et ne pourra plus être modifié par la suite.
            </Typography>
            <Typography variant="subtitle1" gutterBottom>
              Contenu de l'e-mail *
            </Typography>

            <Paper elevation={1} style={{ padding: '5px', marginBottom: '20px' }}>
              <Editor
                value={form.contenu}
                onChange={(e) => setForm({ ...form, contenu: e.target.value })}
                style={{ minHeight: '400px'}}
              />
            </Paper>   
            
              
             {status.text && (
            <Alert severity={status.type}>{status.text}</Alert>
              )}

            <div className="email-template-submit">
              <Button type="submit" variant="contained" disabled={loading}>
                {loading ? <CircularProgress size={20} color="inherit" /> : 'Ajouter'}
              </Button>
            </div>
          </form>
        </Paper>
      </Container>
    </DashboardLayout>
  );
};

export default AddEmailTemplate;
